import { useQueryClient } from '@tanstack/vue-query';
import { type NavigationGuard } from 'vue-router';
import { fetchMarketDataVersions } from '@/market-data/query/market-data';
import { useAuthStore } from '@/stores/auth';

export const redirectToHomeIfNoAccessGranted: NavigationGuard = async () => {
  const authStore = useAuthStore();

  if (authStore.appAccess.nav.market_data) {
    return true;
  } else {
    return { name: 'home' };
  }
};

export const ensureValidVersion: NavigationGuard = async (to) => {
  const queryClient = useQueryClient();

  const versions = await queryClient.fetchQuery({
    queryKey: ['market-data', 'versions'],
    queryFn: fetchMarketDataVersions,
    staleTime: 1_500,
  });

  if (versions.length === 0) {
    return true;
  }

  const currentVersionId = to.query.version ? Number(to.query.version) : null;
  const versionExists = currentVersionId ? versions.some((v) => v.id === currentVersionId) : false;

  if (!versionExists) {
    return {
      ...to,
      query: {
        ...to.query,
        version: String(versions[0].id),
      },
      replace: true,
    };
  }

  return true;
};
